import { CommonTranslationKeys } from 'intl/keys';
import { TranslationKey } from 'intl/types/translationKey';
import { UserRole } from 'shared/types/userRole';

const USER_ROLE_PRICING_LABEL_KEY: Record<UserRole, TranslationKey> = {
  [UserRole.visible_no_access]: CommonTranslationKeys.free,
  [UserRole.standard]: CommonTranslationKeys.free,
  [UserRole.manager]: CommonTranslationKeys.paid,
  [UserRole.viewer]: CommonTranslationKeys.paid,
  [UserRole.projectAdmin]: CommonTranslationKeys.paid,
  [UserRole.organizationAdmin]: CommonTranslationKeys.paid,
  [UserRole.superAdmin]: CommonTranslationKeys.paid,
};

export function userRolePricingLabelKey(role: UserRole): TranslationKey {
  return USER_ROLE_PRICING_LABEL_KEY[role];
}
